import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Context } from '../Context';

//media
import { ReactComponent as CubeIcon } from '../media/img/Menu/model.svg';
import { ReactComponent as TiersIcon } from '../media/img/Menu/tiers.svg';
import { ReactComponent as VisIcon } from '../media/img/Menu/galery.svg';
import { ReactComponent as LocalizationIcon } from '../media/img/Menu/location.svg';
import { ReactComponent as FavIcon } from '../media/img/Menu/favorite.svg';
import { ReactComponent as PlanIcon } from '../media/img/Menu/plan.svg';

import styles from '../styles/bim.module.scss';

import { MOBILE_VIEW_TYPES } from '../constants/mobileViewTypes';
const {
	MODEL_VIEW,
	TIERS_VIEW,
	VISUALIZATIONS_VIEW,
	LOCALIZATION_VIEW,
	APARTMENT_VIEW,
	FAVORITES_VIEW,
} = MOBILE_VIEW_TYPES;

function MobileNavBar() {
	const {
		isMobile,
		apartmentsData,
		mobileActiveView,
		setMobileActiveView,
		filteredApartmentData,
		activeLayer,
		setActiveLayer,
		activeApartment,
		setActiveApartmentHandle,
		tiersData,
		setActiveTier,
		activeTier,
	} = useContext(Context);

	const { t } = useTranslation();

	if (!isMobile) return null;

	function setViewHandle(view) {
		window.scrollTo({ top: 0, behavior: 'smooth' });

		if (view == APARTMENT_VIEW && !activeApartment) {
			setActiveApartmentHandle(filteredApartmentData[0].id_original);
			setMobileActiveView(APARTMENT_VIEW);
		} else {
			setMobileActiveView(view);
		}
	}

	return (
		<div className={styles.mobile_bottom_nav_bar}>
			{/* <div className={`${mobileActiveView == VISUALIZATIONS_VIEW && 'active'}`} onClick={() => {
                setViewHandle(VISUALIZATIONS_VIEW)
            }}>
                <VisIcon />
                <span>
                    {t('gallery')}
                </span>
            </div> */}
			<div
				className={`${mobileActiveView == MODEL_VIEW && 'active'}`}
				onClick={() => {
					setViewHandle(MODEL_VIEW);
				}}
			>
				<CubeIcon />
				<span>{t('3d_cube')}</span>
			</div>
			<div
				className={`${mobileActiveView == TIERS_VIEW && 'active'}`}
				onClick={() => {
					if (!activeTier && tiersData.length > 0 && isMobile) {
						setActiveTier(tiersData[0].ref_tier);
					}
					setViewHandle(TIERS_VIEW);
				}}
			>
				<TiersIcon />
				<span>{t('tiers')}</span>
			</div>
			<div
				className={`${mobileActiveView == LOCALIZATION_VIEW && 'active'}`}
				onClick={() => {
					setViewHandle(LOCALIZATION_VIEW);
				}}
			>
				<LocalizationIcon />
				<span>{t('location')}</span>
			</div>

			<div
				className={`${mobileActiveView == APARTMENT_VIEW && 'active'}`}
				onClick={() => {
					setViewHandle(APARTMENT_VIEW);
				}}
			>
				<PlanIcon />
				<span>{t('apartments')}</span>
			</div>
			<div
				className={`${mobileActiveView == FAVORITES_VIEW && 'active'}`}
				onClick={() => {
					setViewHandle(FAVORITES_VIEW);
				}}
			>
				<FavIcon />
				<span>{t('favorites')}</span>
			</div>
		</div>
	);
}

export default MobileNavBar;
